import request from '@/utils/request'

function QUERY( {key, params}) {
  let url
  // 获取客户消息列表
  if(key=='getMessagelist'){
    url = '/h5/CustomerMessage/getMessagelist'
  }
  // 小程序客户消息-客户消息对话框详情
  if(key=='getMessageDetail'){
    url = '/h5/CustomerMessage/getMessageDetail'
  }

  if (typeof params == 'object') {
    params['version'] = 'MINI'
  } else {
    params = { version: 'MINI' }
  }
  return request({
    url,
    method: 'post',
    params
  })
}

export default QUERY;